import React, { useContext, useEffect, useState } from "react";
import { AnchorWrapper } from "components/EslintCompatible";
import { VerifyOTPSheet } from "./VerifyOTPSheet";
import {
  trackWalletOtpLoad,
  trackWalletOtpInteractions,
} from "layouts/Payment/common/dependencies/tracking";
import { getMaskedMobileNumber } from "layouts/Payment/common/dependencies/dependencyhelpers";
import { WALLET_OTP_STATES } from "constants/dataLayer";
import { DEVICE_TYPE } from "constants/index";
import { ApplicationContext } from "wrapper/ApplicationWrapper/context";

/**
 * @description
 * layout for verify otp component with bottom sheet
 * @returns verify otp bottom sheet
 */
export const VerifyOTP = ({
  sendOtpCallback,
  verifyOtpCallback,
  mobileNumber,
  // state for bottom sheet
  isVerifyOtpVisible,
  setIsVerifyOtpVisible,
}: VerifyOTPProps) => {
  // state for send otp
  const [otpDetails, setOtpDetails] = useState({
    otp_status: false,
    message: "",
    otp_length: 0,
    retry_left: 0,
  });
  const [isResendOtpClicked, setIsResendOtpClicked] = useState(true);
  const maskedNumber = getMaskedMobileNumber(mobileNumber);
  const { applicationData } = useContext(ApplicationContext);
  const { deviceType } = applicationData;

  // call send otp callback function
  useEffect(() => {
    if (isResendOtpClicked) {
      sendOtpCallback().then((response: any) => {
        if (!response) {
          return;
        }
        // tracking logics
        if (!otpDetails?.otp_status) {
          trackWalletOtpLoad();
        } else {
          trackWalletOtpInteractions(WALLET_OTP_STATES.RESEND);
        }
        let { otp_status, message, otp_length, retry_left } = response;
        // setting the response data in otpDetails state
        setOtpDetails({
          otp_status,
          message,
          otp_length,
          retry_left,
        });
      });
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [isResendOtpClicked]);

  // toggle otp sheet
  const toggleVerifyOTPSheet = () => {
    setIsVerifyOtpVisible(!isVerifyOtpVisible);
  };

  return (
    <React.Fragment>
      {isVerifyOtpVisible && (
        <>
          {deviceType === DEVICE_TYPE.MOBILE && (
            <AnchorWrapper
              className="mr10 font-size-16 font-semibold"
              onClick={toggleVerifyOTPSheet}
            >
              Verify OTP
            </AnchorWrapper>
          )}
          <VerifyOTPSheet
            closeVerifyOTPSheet={toggleVerifyOTPSheet}
            otpDetails={otpDetails}
            verifyOtpCallback={verifyOtpCallback}
            mobileNumber={maskedNumber}
            setIsResendOtpClicked={setIsResendOtpClicked}
            isResendOtpClicked={isResendOtpClicked}
          />
        </>
      )}
    </React.Fragment>
  );
};
